import axios_ from "../utils/axios";
import { translateContent } from "./translateFetch";
import qs from "qs";


export default {
  /**
   * 舆情链接列表
   * @param {Object} param
   * @property {number} param.page
   * @property {number} param.page_num
   * @property {string} param.name  链接名称
   * @property {Array} param.dateRange 时间范围
   * @property {Number} param.platform 平台
   * @returns {Promise<DefaultResponseType>}
   */
  getSentimentList(param) {
    return axios_("get", `api/pandagpt/v1/yuqing_link/lists`, param, false, false, true);
  },
  /**
   * 新增舆情链接
   * @param {Object} param
   * @property {string} param.name  链接名称
   * @property {string} param.link 链接地址
   * @property {string} param.platform 平台
   * @returns {Promise<DefaultResponseType>}
   */
  createSentimentLink(param) {
    return axios_("POST", `api/pandagpt/v1/yuqing_link/create`, param, false, false, true);
  },
  /**
   * 舆情链接详情
   * @param {object} param
   * @property {string} param.id  舆情链接ID
   * @returns {Promise<DefaultResponseType>}
   */
  getSentimentDetail(param) {
    return axios_("get", `api/pandagpt/v1/yuqing_link/detail`, param, false, false, true);
  },
  /**
   * 舆情链接删除
   * @param {object} param
   * @property {string} param.id  舆情链接ID
   * @returns {Promise<DefaultResponseType>}
   */
  deleteSentimentLink(param) {
    return axios_("POST", `api/pandagpt/v1/yuqing_link/delete`, param, false, false, true);
  },
  /**
   * 舆情链接 - 评论列表
   * @param {object} param
   * @property {string} param.link_id 舆情链接ID
   * @property {string} param.start_date 开始时间
   * @property {string} param.end_date 结束时间
   * @property {string} param.sort_order 排序方式 asc-正序，desc-倒序
   * @property {string} param.platform 平台 1-Facebook，2-X，4-instagram，5-TikTok，6-YouTube
   * @property {1|2} param.is_link_comment 是否是引导评论：1-是；2-否
   * @property {number} param.page
   * @property {number} param.page_num
   * @returns {Promise<DefaultResponseType>}
   */
  getSentimentComments(param) {
    return axios_("GET", `api/pandagpt/v1/yuqing_link_comment/lists`, param, false, false, true);
  },
  /**
   * 新增舆情链接任务
   * @param {Object} param
   * @property {string} param.name 任务名称
   * @property {string} param.link_id 链接id
   * @property {string} param.country_language 评论账号国家语种
   * @property {string} param.comment 评论文案内容，分隔符：[--------分隔符--------]
   * @returns {Promise<DefaultResponseType>}
   */
  createSentimentTask(param) {
    return axios_("POST", `api/pandagpt/v1/yuqing_task/create`, param, false, false, true);
  },
  /**
   * 链接任务列表
   * @param {Object} param
   * @property {number} param.page
   * @property {number} param.page_num
   * @property {string} param.link_id 链接 id
   * @returns {Promise<DefaultResponseType>}
   */
  getSentimentTaskList(param) {
    return axios_("get", `api/pandagpt/v1/yuqing_task/lists`, param, false, false, true);
  },
  /**
   * 链接任务详情
   * @param {Object} param
   * @property {string} param.id 任务id
   * @returns {Promise<DefaultResponseType>}
   */
  getSentimentTaskDetail(param) {
    return axios_("get", `api/pandagpt/v1/yuqing_task/detail`, param, false, false, true);
  },
  /**
   * 删除链接任务
   * @param {Object} param
   * @property {string} param.id 任务id
   * @returns {Promise<DefaultResponseType>}
   */
  deleteSentimentTask(param) {
    return axios_("POST", `api/pandagpt/v1/yuqing_task/delete`, param, false, false, true);
  },
  /**
   * 重新发布任务
   * @param {Object} param
   * @property {string} param.id 任务id
   * @returns {Promise<DefaultResponseType>}
   */
  publishSentimentTask(param) {
    return axios_("POST", `api/pandagpt/v1/yuqing_task/publish`, param, false, false, true);
  },

  /**
   * 手动更新舆情链接
   * @param {Object} param
   * @property {string} param.id 链接id
   * @returns {Promise<DefaultResponseType>}
   */
  updateLinkContent(param) {
    return axios_("POST", `api/pandagpt/v1/yuqing_link/manual_update`, param, false, false, true);
  },
  /**
   * 根据平台获取国家
   * @param {Object} param
   * @property {string} param.platform 平台：1-Facebook， 2-X，4-instagram，5-TikTok，6-YouTube
   * @returns {Promise<DefaultResponseType>}
   */
  sentimentTaskCountry(param) {
    return axios_("POST", `api/pandagpt/v1/yuqing_task/get_countries`, param, false, false, true);
  },

  /**
   * 翻译（已切换到统一接口，建议直接使用 translateContent）
   * @param {Object} param
   * @property {string} param.text  翻译文本
   * @returns {Promise<{code:number;msg:string;data:string}>}
   */
  textTranslate(param) {
    return translateContent(param?.text || "", param);
  },
  /**
   * 评论回复模板列表
   */
  sentimentTemplateList(param) {
    return axios_("GET", "api/pandagpt/v1/yuqing_template/lists", param, false, false, true);
  },
  /**
   * 舆情数据统计
   * @param {Object} param
   * @property {string} param.start_date 开始时间
   * @property {string} param.end_date 结束时间
   * @property {Number} param.platform 平台
   * @returns {Promise<DefaultResponseType>}
   */
  publicSentimentLineData(param) {
    return axios_("get", `api/pandagpt/v1/yuqing_statistic/dogleg_datas`, param, false, false, true);
  },
  /**
   * 舆情统计 导出
   * @param {Object} param
   * @property {string} param.link_id 任务id
   * @returns {Promise<DefaultResponseType>}
   */
  exportSentimentTask(param) {
    return axios_("POST", `api/pandagpt/v1/yuqing_statistic/export_comments`, param, false, false, true);
  },
  /**
   * 社媒监控 列表
   * @param {Object} param
   * @returns {Promise<DefaultResponseType>}
   */
  socialMediaList(param) {
    return axios_("GET", `api/pandagpt/v1/stat_media/lists`, param, false, false, true, false);
  },
  /**
   * 社媒监控各平台主页数量统计；筛选参数与主页列表保持一致，用于顶部平台 Tab 的实时数量。
   * @param {{start_date:string; end_date:string; page_name?:string; platform?:number; page_auth_status?:number; label_id?:string}} param
   * @returns {Promise<DefaultResponseType>}
   */
  socialMediaPlatformCount(param) {
    return axios_("GET", `api/pandagpt/v1/stat_media/numerate`, param, false, false, true, false);
  },
  /**
   * 社媒监控各平台最近更新时间；筛选参数与主页列表一致，用于页面右上角的更新状态。
   * @param {{start_date:string; end_date:string; page_name?:string; platform?:number; page_auth_status?:number; label_id?:string}} param
   * @returns {Promise<DefaultResponseType>}
   */
  socialMediaLatestUpdateTime(param) {
    return axios_("GET", `api/pandagpt/v1/stat_media/latest_update_time`, param, false, false, true, false);
  },
  /**
   * 搜索公共主页接口
   * @param {Object} param
   * @returns {Promise<DefaultResponseType>}
   */
  searchPublicPages(param) {
    return axios_("GET", `api/pandagpt/v1/stat_media/search_page`, param, false, false, true, false);
  },
  /**
   * 新增公共主页账号
   * @param {Object} param
   * @returns {Promise<DefaultResponseType>}
   */
  storeSentimentPages(param) {
    return axios_("POST", `api/pandagpt/v1/stat_media/create`, param, false, false, true, false);
  },
  /**
   * 删除监控
   * @param {Object} param
   * @returns {Promise<DefaultResponseType>}
   */
  removeSentimentPage(param) {
    return axios_("POST", `api/pandagpt/v1/stat_media/page_del`, param, false, false, true, false);
  },

  /**
   * 导出tiktok视频流量来源
   */
  export_lists(query) {
    const baseURL = process.env.VUE_APP_PY_CN_API_URL;
    query.token = localStorage.getItem("token") || "";
    window.open(`${baseURL}api/pandagpt/v1/stat_media/export_lists?${qs.stringify(query)}`);
  },
};
